import { Flex } from '@smarterservices/smarter-ui';
import DualPane from '../../../DualPane';
import StepInstructions from '../../../Common/StepInstructions';

const SecondCameraIntroduction = ({ stepData, setIsTaskComplete }) => {
  
  return (
    <DualPane
      leftPane={
        <StepInstructions instructions={stepData?.body} />
      }
      rightPane={
        <Flex direction="column" padding="medium" alignItems="center">

         HI
        </Flex>
      }
    />
  );
};

export default SecondCameraIntroduction;
